export default __webpack_public_path__ + "static/media/tile-4-long.6fa78d29.png";